var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('prozess-metastatus-table',{attrs:{"custom-service":_vm.service,"is-system-settings-permissions":true,"resource-name":_vm.resourceName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }